import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { COUNTDOWN_LABEL } from './constants';
export var TimerMinSecs = function (_a) {
    var time = _a.time, _b = _a.label, label = _b === void 0 ? COUNTDOWN_LABEL : _b;
    return (_jsxs(_Fragment, { children: [_jsx("span", { children: label }), _jsxs("span", { children: [withZero(Math.floor(time / 60)), ":", withZero(time % 60)] })] }));
};
export var CountdownTimer = function (_a) {
    var initialTime = _a.initialTime;
    var _b = useState(initialTime), countDown = _b[0], setCountDown = _b[1];
    useEffect(function () {
        var interval = setInterval(function () {
            setCountDown(function (currentTime) { return currentTime - 1; });
        }, 1000);
        if (countDown <= 0)
            clearInterval(interval);
        return function () { return clearInterval(interval); };
    }, [initialTime]);
    return _jsx(TimerMinSecs, { time: countDown });
};
var withZero = function (n) { return (n < 0 ? '00' : (n < 10 ? '0' : '') + n); };
